import Axios from "axios";

export const backend = {
  namespaced: true,
  state: {
    lang: "ja", // 言語
  },
  getters: {
    lang(state) {
      return state.lang;
    },
  },
  mutations: {
    setLang(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
    async getRequestToBackend(_context, { path, bodyParams }) {
      return await Axios.get(
        `${process.env.VUE_APP_BACKEND_API_URL}${path}`,
        _context.rootGetters["common/APIRequestHeader"],
        {
          params: bodyParams,
        }
      );
    },

    async postRequestToBackend(_context, { path, bodyParams }) {
      return await Axios.post(
        `${process.env.VUE_APP_BACKEND_API_URL}${path}`,
        bodyParams,
        _context.rootGetters["common/APIRequestHeader"],
        {}
      );
    },

    async putRequestToBackend(_context, { path, bodyParams }) {
      await Axios.put(
        `${process.env.VUE_APP_BACKEND_API_URL}${path}`,
        bodyParams,
        _context.rootGetters["common/APIRequestHeader"]
      );
    },

    async deleteRequestToBackend(_context, { path, bodyParams }) {
      try {
        await Axios.delete(
          `${process.env.VUE_APP_BACKEND_API_URL}${path}`,
          _context.rootGetters["common/APIRequestHeader"],
          bodyParams
        );
      } catch (err) {
        throw new Error("UnhandlableError");
      }
    },

    async getUser(context, { id }) {
      var params = {};
      const resp = await context.dispatch("getRequestToBackend", {
        path: `users/${id}`,
        bodyParams: params,
      });
      console.log("resp :>> ", resp);
    },

    async getUserProfile(context, { id }) {
      var params = {};
       const resp = await context.dispatch("getRequestToBackend", {
        path: `users/${id}/profile`,
        bodyParams: params,
      });
      console.log("resp :>> ", resp);
      return resp;
    },
  },
};
